<template>
    <div class="text-center">
        <v-dialog max-width="550" v-model="showChangePassword">
            <template v-slot:activator="{ on }">
                <v-btn text
                    v-on="on"
                    slot="activator"
                    depressed
                    color="var(--feature)"
                    dark
                    rounded
                    large
                    class="px-12">
                    <v-icon class="mr-3" small>fal fa-lock</v-icon>Alterar Senha
                </v-btn>  
            </template>
             <v-card>
                  <v-card-title>
                         <h5 class="pt-5 pb-7">Senha</h5>
                 </v-card-title>
                 <v-card-text>
                    <v-form v-model="isFormValid">
                        <v-row>
                            <v-col cols="12">
                                 <v-text-field 
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="showPassword ? 'text' : 'password'"
                                    label="Senha atual"
                                    v-model="valueActualPassword"
                                    @click:append="showPassword = !showPassword"
                                    outlined
                                    hide-details="auto"
                                    required
                                 ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min]"
                                    :type="showPassword ? 'text' : 'password'"
                                    v-model="valueNewPassword"
                                    label="Nova senha"
                                    @click:append="showPassword = !showPassword"
                                    outlined
                                    loading
                                    hide-details="auto"
                                    required
                                >
                                      <template v-slot:progress>
                                        <v-progress-linear
                                            :value="progress"
                                            :color="color"
                                            absolute
                                            height="7"
                                            class="mt-1"
                                        ></v-progress-linear>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                             <v-col cols="12">
                                 <v-text-field
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="showPassword ? 'text' : 'password'"
                                    label="Confirme a senha"
                                    @click:append="showPassword = !showPassword"
                                    outlined
                                    v-model="valueConfPassword"
                                    hide-details="auto"
                                    :rules="[valueNewPassword==valueConfPassword]"
                                    required
                                 ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                 </v-card-text>
                 <v-divider class="lg" />
                  <v-card-actions class="px-6 py-5 d-flex space-between">
                    <v-btn rounded large depressed outlined class="gray px-12" @click="hide()">Voltar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        large
                        rounded
                        depressed
                        class="px-12"
                        @click="changePassword()"
                        :disabled="!isFormValid"
                    >Alterar senha</v-btn>
                </v-card-actions>
             </v-card>

             <template>
                <v-dialog v-model="showChangePasswordMessageDialog" persistent max-width="490">
                    <v-card>
                        <v-card-title>
                            <h5 class="pt-5 pb-7">Atualização de Senha</h5>
                        </v-card-title>
                        <v-card-text>{{changePasswordMessage}}</v-card-text>
                        <v-spacer></v-spacer>
                        <v-card-actions class="px-6 py-5">
                            <v-btn
                                color="gray"
                                text
                                large
                                class="px-12"                            
                                @click="closeUpdatePasswordDialogAndCleanFields()"
                            >Entendi</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
        </v-dialog>
    </div>
</template>

<script>
import AuthService from "@/scripts/services/auth.service";

export default {
    props: {
        
    },
    name: "ChangePassword",
    data: () => ({
        authService: new AuthService(),
        isFormValid: false,
        showPassword: false,
        valueActualPassword: "",
        valueNewPassword: "",
        valueConfPassword: "",
        changePasswordMessage: "",
        showChangePasswordMessageDialog: false,
        showChangePassword: false,

        rulesPassword: {
            min: v => v.length >= 8 || "Mínimo de 8 caracteres alfanuméricos."
        },
        rules: {
            required: value => !!value || "Required.",
            rulePassword: v =>
                v.length >= 5 || "Sua senha deve ter mais que 8 caracters"
        },
    }),
    methods: {
        hide() {
            this.showChangePassword = false;
            this.$emit("input", this.value);
        },
        changePassword() {
            let passwordModel = {
                oldPassword: this.valueActualPassword,
                newPassword: this.valueConfPassword
            };
            if (this.loading) return;
            this.loadingCount = true;
            this.authService
                .changePassword(passwordModel)
                .then(this.changePasswordCallback)
                .catch(this.changePasswordCatch);
        },
         changePasswordCallback(){
            this.changePasswordMessage = "Sua senha foi atualizada com Sucesso!";
            this.showChangePasswordMessageDialog = true;
            
            this.valueActualPassword = "";
            this.valueConfPassword = "";
            this.valueActualPassword = "";
        },
        changePasswordCatch(){
            this.changePasswordMessage = "Não foi possível atualizar sua senha";
            this.showChangePasswordMessageDialog = true;
            this.valueActualPassword = "";
            this.valueConfPassword = "";
            this.valueActualPassword = "";
        },
        closeUpdatePasswordDialogAndCleanFields() {
            this.showChangePasswordMessageDialog = false;
            this.showChangePassword = false;
            this.valueActualPassword = "";
            this.valueConfPassword = "";
            this.valueActualPassword = "";
        },
    },
    computed: {
        progress() {
            return Math.min(100, this.valueNewPassword.length * 12.5);
        },
        color() {
            return ["error", "warning", "success"][
                Math.floor(this.progress / 40)
            ];
        }
    },
}

</script>
